<!--
 * @Desc:
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-27 19:12:16
-->
<template>
    <div class="app-container">
        <!-- 查询条件 -->
        <div class="search-div common-section-bg">
            <div class="shaixuan-item">
                <el-input v-model="queryParam.name"
                          size="mini"
                          clearable
                          placeholder="请输入姓名查找" />
            </div>
            <div class="shaixuan-item">
                <el-input v-model="queryParam.phone"
                          size="mini"
                          clearable
                          placeholder="请输入手机号查找" />
            </div>
            <div class="shaixuan-item">
                <el-button type="primary"
                           size="mini"
                           style=" background: #1067e0;border-color: #1067e0;"
                           @click="searchClick()"
                           icon="el-icon-search">
                    查询
                </el-button>
                <el-button type="primary"
                           icon="el-icon-refresh"
                           @click="syncData">
                    同步
                </el-button>
                <!-- <el-button @click="clickItem(0)"
                           type="primary"
                           size="mini"
                           icon="el-icon-plus">
                  新增
                </el-button> -->
            </div>
        </div>
        <!-- 列表展示 -->
        <div class="common-section-bg common-section-body">
            <el-table v-loading="listLoading"
                      :data="tableData"
                      size="mini"
                      style="width: 100%; min-height: 300px">
                <el-table-column prop="id"
                                 label="id"
                                 width="80" />
                <el-table-column prop="name" label="姓名" minwidth="200" />
                <el-table-column prop="phone" label="手机号" minwidth="200" />
                <el-table-column label="头像" width="200" >
                    <template slot-scope="scope">
                        <el-image
                                style="width: 100px; height: 100px"
                                :src="$adddom(scope.row.avatar)"
                                :preview-src-list="[$adddom(scope.row.avatar)]">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="kf_url" label="客服链接" minwidth="200" />
                <el-table-column fixed="right"
                                 align="center"
                                 label="操作"
                                 width="220">
                    <template slot-scope="scope">
                   <el-button type="danger"
                                   style="
                                                background: #42d885;
                                                border-color: #42d885;
                                            "
                                   size="mini"
                                   @click="clickItem(1, scope.row)">修改</el-button>

<!--                        <el-button type="danger"-->
<!--                                   style="-->
<!--                                    background: #1067e0;-->
<!--                                    border-color: #1067e0;-->
<!--                                "-->
<!--                                   size="mini"-->
<!--                                   @click="clickDetail(scope.row)">详情</el-button>-->
                      <el-button type="danger"
                                   @click="remove(scope.row)"
                                   size="mini">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <pagination v-show="total"
                        :total="total"
                        :page.sync="queryParam.page"
                        :limit.sync="queryParam.size"
                        @pagination="getList" />
        </div>
        <el-drawer custom-class="custom-drawer"
                   :visible.sync="showDrawer"
                   :close-on-press-escape="false"
                   :wrapper-closable="false"
                   :show-close="false"
                   size="532px">
            <template slot="title">
                <div class="custom-title">
                    <div class="title-name">{{ isEdit ? "编辑" : "新增" }}</div>
                    <i class="el-icon-circle-close close-btn pointer"
                       @click="closeDrawerFun" />
                </div>
            </template>
            <div class="custom-content">
                <RoleAdd ref="RoleAdd"
                         @onUpdateDrawer="onUpdateDrawer($event)" />
            </div>
        </el-drawer>
    </div>
</template>

<script>
  import { Loading } from "element-ui";
  import Cookies from "js-cookie";
  import fetch from "@/api/tianzheng/Qu";
  import guanjia from '@/api/tianzheng/guanjia'
  import RoleAdd from "./GuanjiaAdd.vue";
  import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
  export default {
    data () {
      return {
        pageLoading:'',
        queryParam: {
          commId: '',
          name: "",
          phone: "",
          page: 1,
          size: 10,
        },
        total: 0,
        listLoading: false,
        tableData: [],
        isEdit: 0, // 0新增 1编辑
        showDrawer: false,
        showDetail:false
      };
    },
    components: {
      Pagination,
      RoleAdd,
    },
    created () {
      this.queryParam.commId = this.$route.query.id
    },
    mounted () {
      this.getList();
    },
    methods: {
      // 同步数据
      syncData(){
        const that = this
        that.$confirm('确定同步该小区管家吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            // 调用接口
            that.pageLoading = Loading.service({
              lock: true,   //是否锁定屏幕的滚动
              text: "加载中……",  //loading下面的文字
              background: "rgba(0, 0, 0, 0.7)",  //loading的背景色
              target:"body"      //loading显示在容器
            });
            guanjia.sync({commId:this.queryParam.commId}).then((res) => {
              that.pageLoading.close();
              that.pageLoading = null;
              if (res.code == 200) {
                that.$message.success(res.message)
                that.getList()
              } else {
                that.$message.error(res.message)
              }
            })
          })
          .catch(() => {
            that.pageLoading.close();
            that.pageLoading = null;
          })
      },
      /**
       * @name: 更改状态
       * @param {*} val
       * @return {*}
       * @desc:
       */
      // 更新弹层状态
      onUpdateDrawer (status) {
        console.log("status", status);
        if (status == 1) {
          // 成功
          this.showDrawer = false;
          this.showDetail = false;
          this.getList();
        } else if (status == -1) {
          // 失败
          this.showDrawer = false;
          this.showDetail = false;
        }
      },
      /**
       * @name: 关闭弹层
       * @return {*}
       * @desc:
       */
      closeDrawerFun () {
        this.showDrawer = false;
        this.showDetail = false;
        if (this.$refs.RoleAdd){
          this.$refs.RoleAdd.resetForm();
        }
      },
      /**
       * @name: 点击子项 0新增 1编辑
       * @param {*} type
       * @param {*} id
       * @return {*}
       * @desc:
       */
      clickItem (type, row) {
        let that = this;
        this.showDrawer = true;
        this.isEdit = type;
        // 给组件传值
        let obj = {
          type: type,
          id: row ? row.id : "",
        };
        this.$nextTick(function () {
          that.$refs.RoleAdd.initFun(obj);
        });
      },
      clickDetail(row){
        let that = this
        this.showDetail = true;
        let obj = {
          id: row ? row.id : "",
        };
        this.$nextTick(function () {
          that.$refs.ResourceDetail.initFun(obj);
        });
      },
      /* 查询按钮，页码重置，查询数据 */
      searchClick () {
        this.queryParam.page = 1;
        this.getList();
      },
      /* 查询tableData数据 */
      getList () {
        let that = this;
        this.listLoading = true;
        guanjia.list(that.queryParam).then((res) => {
          that.listLoading = false;
          that.tableData = res.result.list;
          that.total = res.result.total;
        });
      },
      remove(row) {
        let that = this;
        that.$confirm("确定删除该内容吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            // 调用接口
            guanjia.remove({ id: row.id }).then((res) => {
              if (res.code == 200) {
                that.$message.success(res.message);
                that.getList();
              } else {
                that.$message.error(res.message);
              }
            });
          })
          .catch(() => {});
      },
    },
  };
</script>

<style lang="scss" scoped>
    .app-container {
        min-height: calc(100vh - 98px);
    }
</style>
